import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { toast } from 'react-toastify';
import { get, isNil } from 'lodash';
import { TextField } from '@material-ui/core';
import { translate } from 'containers/services/translate';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { StyledDiv } from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/Dialog/styles';
import messages from 'containers/TransactionManagerTimeLine/DecisionDialog/messages';
import DecisionDialog from 'components/DecisionDialog/index';
import { STATUS_REJECTED } from 'containers/LawyerFeeNote/constants';
import currentUserStorage from 'containers/services/security/current-user-storage';
import { getTheLatestEvaluationObject } from 'containers/LawyerLegalProceedingsPage/judgementAdd/IncomeCertificate/utils';
import {
  formatLastEvaluation,
  formatTransactionCircumstances,
  formatClaimCircumstances,
  lastEvaluationOfOtherVictims,
} from 'containers/TransactionManagerTimeLine/DecisionDialog/utils';
import { getVictimAge } from 'containers/CourtManagerLegalProceedings/ExpertReport/utils';
import { TransactionType } from 'typings/globalTypes';
import { VICTIM } from 'containers/data-structure';
import { INJURY_POST_DECEASED } from 'containers/PreOpeningPage/constants';
import { formatNextOfKinsToAdd } from 'containers/RecapManagerPage/utils';
import { Beneficiary } from 'containers/PreOpeningPage/typings';

export interface DecisionStepDialogProps {
  intl: IntlShape;
  isManager: Boolean;
  open: boolean;
  handleClose: any;
  status: string;
  timeLine: any;
  requestMakeDecisionVictimInfo: Function;
  transactionInfo: TransactionType;
  riskId: any;
  dahirAmounts: any;
  victimKey: any;
  claim: any;
  victims: any;
}

export const DecisionStepDialog: React.FC<DecisionStepDialogProps> = (
  props,
): JSX.Element => {
  const [reason, setReason] = React.useState(null);
  const handleChangeReason = (event: any) => {
    setReason(event.target.value);
  };

  const handleValidate = () => {
    const lastEvaluationOfOtherVictim = lastEvaluationOfOtherVictims(
      props.victims?.filter((item: any) => item.victimKey != props.victimKey),
      props.dahirAmounts,
    );
    const lastEvaluation = getTheLatestEvaluationObject(
      props.victimKey,
      props.dahirAmounts,
    );
    props.requestMakeDecisionVictimInfo(
      {
        timeLineId: get(props.timeLine, 'id'),
        status: props.status,
        comment: reason,
        decidedBy: currentUserStorage?.get().username,
        decidedAt: new Date(),
        transactionId: get(props.transactionInfo, 'id'),
        claimId: Number(get(props.transactionInfo, 'claimId')),
        victimId: get(props.transactionInfo, 'victimId'),
        victimsSagis: [],
        isTransactionInboxesActive: featureService.hasFeature(
          FEATURES.INBOXES_TRANSACTION_MANAGER,
        ),
        riskKey: props.riskId,
        nextOfKins:
          String(get(props.transactionInfo, 'victim.injuryPostKey', null)) ===
          INJURY_POST_DECEASED
            ? formatNextOfKinsToAdd(
                get(props.transactionInfo, 'victim.beneficiaries', []),
                props.victimKey,
              )
            : [],
        sagisEvaluations: formatLastEvaluation(
          lastEvaluation,
          getVictimAge(
            get(props.transactionInfo, 'victimId'),
            [get(props.transactionInfo, 'victim')],
            get(props.claim, 'lossDate', ''),
          ),
          get(props.transactionInfo, 'victim'),
          get(props.transactionInfo, 'scaleCase.responsibilityShare'),
          props.status,
          lastEvaluationOfOtherVictim,
          props.victims?.filter(
            (item: any) => item.victimKey != props.victimKey,
          ),
          get(props.claim, 'lossDate', ''),
        ),
        claimCircumstances: formatClaimCircumstances(
          props.transactionInfo,
          props.status,
        ),
        transactionCircumstances: formatTransactionCircumstances(
          props.status,
          props.transactionInfo,
          props.riskId,
        ),
      },
      successCallback,
    );
  };
  const successCallback = () => {
    toast.success(translate(messages.validationToastSuccess, props));
    props.handleClose();
  };

  return (
    <DecisionDialog
      open={props.open}
      onClose={props.handleClose}
      validateDialog={handleValidate}
      title={translate({ ...messages.decisionTitle }, props)}
      content={
        <StyledDiv>
          {translate(messages.courtManagerConfirmationDialogContent, props)}
          {props.status === STATUS_REJECTED && (
            <TextField
              onChange={handleChangeReason}
              name={'reason'}
              value={reason}
              label={translate({ ...messages.reason }, props)}
              className="input"
              multiline
              fullWidth
            />
          )}
        </StyledDiv>
      }
      disabled={props.status === STATUS_REJECTED && !reason}
      primaryButtonTitle={translate(messages.dialogValidationButton, props)}
      scondaryButtonTitle={translate(messages.dialogCancelButton, props)}
    />
  );
};

export default injectIntl(DecisionStepDialog);
